import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/attributes/constants';

export const columnCriteriaStripeData: {caption: string, type: ColumnTypes}[] = [
    {caption: COLUMN_CAPTIONS[ColumnTypes.ATTRIBUTE], type: ColumnTypes.ATTRIBUTE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.DATA_TYPE], type: ColumnTypes.DATA_TYPE},
    {caption: COLUMN_CAPTIONS[ColumnTypes.EVENT_CODES], type: ColumnTypes.EVENT_CODES},
];
